import { TextColor } from '../../../types';
import { Typography } from '../Typography';
import { ProgressBarProps } from './ProgressBar.types';

const ProgressBar = ({ value, max = 100 }: ProgressBarProps) => {
  const progressPercentage = (value / max) * 100;

  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="h-2 w-full overflow-hidden rounded-full bg-base-300">
        <div
          className="h-full rounded-full bg-base-content/60 transition-all duration-300"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <Typography color={TextColor.SECONDARY}>{value}%</Typography>
    </div>
  );
};
export default ProgressBar;
